export function getCurrencySymbol(taxSystem) {
  return taxSystem === 'CH' ? 'CHF' : '€';
}

export function formatCurrency(amount, taxSystem) {
  const symbol = getCurrencySymbol(taxSystem);
  return `${amount.toFixed(2)} ${symbol}`;
}

